import TypeError from '.TypeError';
import test from '.RegExp.prototype.test';

import * as is from './is';
import { has as allowRelativeSelectorList } from './is';
import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';
import IdSelector from './IdSelector';
import TypeSelector from './TypeSelector';
import ClassSelector from './ClassSelector';
import AttributeSelector from './AttributeSelector';
import Parenthesis from './Parenthesis';

const notPseudo = /*#__PURE__*/test.bind(/^(?:dir|lang|nth-(?:last-)?(?:col|of-type)|part|state|theme)$/i);
//	not
//		标准
//			:dir()
//			:lang()
//			:nth-$last$-of-type()
//			::part(ident+)
//		废弃
///		实验
///			:nth-$last$-col()
///			:state()
///			::theme()
//	part
///		实验
///			:nth-$last$-child(+n+1 n+1 odd oF.class)
//	is
//		标准
//			:host()
//			:host-context()
//			::slotted()
//			:is()
//			:not()
//			:where()
//			:has(>*)
//		废弃
//			:*any()
//			:matches()
//		实验
//			:current()
const isNthChild = /*#__PURE__*/test.bind(/^nth-(?:last-)?child$/i);

const inNthChild = (complexSelector                 ) => ( complexSelector[TOKEN.parent][TOKEN.parent].constructor                                                                                                 )===NthChild;

const followCombinator = ({ lastItem }                ) => lastItem==='>' || lastItem==='+' || lastItem==='~' || lastItem==='||';

const missingCompoundSelector = ({ lastItem }                 ) => !lastItem || lastItem===',' || lastItem==='>' || lastItem==='+' || lastItem==='~' || lastItem==='||';

const IS_NTH_START = /*#__PURE__*/test.bind(/^(?:\+(?:\d+n?)?|-(?:\d+n?|n(?:-\d+)?)|\d+n?|even|n(?:-\d+)?|odd)$/i);
const IS_NTH_WHOLE = /*#__PURE__*/test.bind(/^(?:[+-]?(?:\d+(?:n(?:[+-]\d+)?)?|event|n(?:[+-]\d+)?)|odd)$/i);

const STATE_BEFORE_NTH = 1         ;
const STATE_DURING_NTH = 2         ;
const STATE_AFTER_NTH = 3         ;
const STATE_OF = 4         ;
const STATE_AFTER_OF = 5         ;

class NthChild extends Layer       {
	
	get [Symbol.toStringTag] () { return 'NthChild'; }
	
	                 pseudoLiteral        ;
	        _state                        = STATE_BEFORE_NTH;
	nthLiteral         = '';
	ofLiteral         = '';
	sLayer                      = null;
	
	constructor (pseudoLiteral        ) {
		///
		super();
		this.pseudoLiteral = pseudoLiteral;
		return this;
	}
	
	[TOKEN.consume] (              ) {
		switch ( this._state ) {
			case STATE_BEFORE_NTH:
				switch ( TOKEN.type ) {
					case TOKEN.comment:
					case TOKEN.whitespace:
						return this;
					case TOKEN.ident:
					case '+':
					case TOKEN.number:
					case TOKEN.dimension:
						if ( !IS_NTH_START(TOKEN.literal) ) { break; }
						this.nthLiteral = TOKEN.literal;
						this._state = STATE_DURING_NTH;
						return this;
				}
				break;
			case STATE_DURING_NTH:
				switch ( TOKEN.type ) {
					case TOKEN.comment:
						return this;
					case TOKEN.ident:
					case '+':
					case TOKEN.number:
					case TOKEN.dimension:
						this.nthLiteral += TOKEN.literal;
						return this;
					case ')':
						if ( !IS_NTH_WHOLE(this.nthLiteral) ) { break; }
						this._state = 0;
						return this[TOKEN.parent];
					case TOKEN.whitespace:
						if ( !IS_NTH_WHOLE(this.nthLiteral) ) { break; }
						this._state = STATE_AFTER_NTH;
						return this;
				}
				break;
			case STATE_AFTER_NTH:
				switch ( TOKEN.type ) {
					case TOKEN.comment:
					case TOKEN.whitespace:
						return this;
					case ')':
						this._state = 0;
						return this[TOKEN.parent];
					case TOKEN.ident:
						if ( !is.of (TOKEN.literal) ) { break; }
						this.ofLiteral = TOKEN.literal;
						this._state = STATE_OF;
						return this;
				}
				break;
			case STATE_OF:
				switch ( TOKEN.type ) {
					case TOKEN.comment:
						return this;
					case TOKEN.whitespace:
						this._state = STATE_AFTER_OF;
						return this;
				}
				break;
			case STATE_AFTER_OF:
				switch ( TOKEN.type ) {
					case TOKEN.comment:
					case TOKEN.whitespace:
						return this;
					case ')':
						break;
					default:
						TOKEN.stay();
						this._state = 0;
						return this.sLayer = new SelectorList(this);
				}
				break;
		}
		return null;
	}
	
	[Symbol.toPrimitive] (              ) {
		return `${this.pseudoLiteral}(${this.nthLiteral}${this.sLayer ? ` ${this.ofLiteral} ${this.sLayer}` : ''})`;
	}
	
	* [Symbol.iterator] (              ) { throw TypeError(`beautify nthChild`); }
	
	                                        
	
	static default = protect(this);
	
}

class ComplexSelector extends Layer                                                                                                                    {
	
	containsScope (                       isScoped                                                  )          {
		const { length } = this;
		let index = 0;
		do {
			const each = this[index] ;
			switch ( each.constructor ) {
				case ClassSelector:
				case IdSelector:
				//case TypeSelector:
				//case AttributeSelector:
					if ( isScoped('' + each) ) { return true; }
					break;
				case ComplexSelector:
					if ( ( each                    ).containsScope(isScoped) ) { return true; }
					break;
				case NthChild:
					const { sLayer } = each            ;
					if ( sLayer ) {
						const { length } = sLayer;
						let index = 0;
						do { if ( sLayer[index] .containsScope(isScoped) ) { return true; } }
						while ( ++index!==length );
					}
					break;
			}
		}
		while ( ++index!==length );
		return false;
	}
	
	get [Symbol.toStringTag] () { return 'ComplexSelector'; }
	
	                 pseudoLiteral        ;
	        _hold                                             = '';
	
	constructor (pseudoLiteral        ) {
		super();
		this.pseudoLiteral = pseudoLiteral;
		return this;
	}
	
	[TOKEN.consume] (                     ) {
		if ( TOKEN.type===TOKEN.comment ) { return this; }
		if ( this._hold && TOKEN.type!==TOKEN.ident ) {
			switch ( this._hold ) {
				case ':':
					if ( TOKEN.type===':' ) {
						this._hold = '::';
						return this;
					}
				case '::':
					if ( TOKEN.type===TOKEN.function_ ) { break; }
					return null;
				case '.':
					return null;
				case '|':
					if ( TOKEN.type==='*' ) { break; }
					///if ( TOKEN.type==='|' && !( allowRelativeSelectorList!(this.pseudoLiteral) ? followCombinator : missingCompoundSelector )(this) ) { break; }
					return null;
				default:
					if ( TOKEN.type==='*' ) { break; }
					return null;
			}
		}
		switch ( TOKEN.type ) {
			case TOKEN.whitespace:
				missingCompoundSelector(this) || ( this.newItem = ' ' );
				return this;
			case TOKEN.ident:
				switch ( this._hold ) {
					case '':
						const constructorOfLastItem = this.length && this.lastItem .constructor;
						if ( constructorOfLastItem===TypeSelector || constructorOfLastItem===IdSelector ) { return null; }
						this.newItem = new TypeSelector(TOKEN.literal, null);
						break;
					case '.':
						this.newItem = new ClassSelector(TOKEN.literal);
						break;
					case ':':
					case '::':
						this.newItem = this._hold + TOKEN.literal;
						break;
					case '|':
						const { lastItem } = this;
						if ( lastItem && lastItem.constructor===TypeSelector ) {
							if ( lastItem.namespaceLiteral!==null ) { return null; }
							lastItem.namespaceLiteral = lastItem.elementNameLiteral;
							lastItem.elementNameLiteral = TOKEN.literal;
							break;
						}
					default:
						this.newItem = new TypeSelector(TOKEN.literal, this._hold.slice(0, -1));
						break;
				}
				this._hold = '';
				return this;
			case ',':
				if ( this.pseudoLiteral ) {
					const { lastItem } = this;
					if ( !lastItem || lastItem===',' ) { return null; }
					this[lastItem===' ' ? this.lastIndex : this.length] = TOKEN.literal;
					return this;
				}
				if ( missingCompoundSelector(this) ) { return null; }
				if ( inNthChild(this) ) {
					this[this.lastItem===' ' ? this.lastIndex : this.length] = TOKEN.literal;
					return this;
				}
				this.lastItem===' ' && ( --this.length );
				return this[TOKEN.parent];
			case '>':
			case '+':
			case '~':
				if ( ( allowRelativeSelectorList (this.pseudoLiteral) ? followCombinator : missingCompoundSelector )(this) ) { return null; }
				this[this.lastItem===' ' ? this.lastIndex : this.length] = TOKEN.literal;
				return this;
			case ':':
				this._hold = ':';
				return this;
			case '|':
				if ( this._hold ) {
					this[this.lastItem===' ' ? this.lastIndex : this.length] = '||';
					this._hold = '';
				}
				else { this._hold = '|'; }
				return this;
			case '.':
				this._hold = TOKEN.type;
				return this;
			case '*':
				if ( this._hold ) {
					this.newItem = new TypeSelector('*', this._hold.slice(0, -1));
					this._hold = '';
				}
				else { this.newItem = new TypeSelector('*', null); }
				return this;
			case TOKEN.hash:
				this.newItem = new IdSelector(TOKEN.literal.slice(1));
				return this;
			case '[':
				return this.newItem = new AttributeSelector;
			case TOKEN.function_:
				const colons = this._hold;
				if ( !colons || is.url_ (TOKEN.literal) ) { return null; }
				this._hold = '';
				const nameLiteral = TOKEN.literal.slice(0, -1);
				return this.newItem = new ( notPseudo(nameLiteral) ? Parenthesis : isNthChild(nameLiteral) ? NthChild : ComplexSelector )(colons + nameLiteral);
			case '{':
				if ( this.pseudoLiteral ) { return null; }
				if ( inNthChild(this) ) { return null; }
				if ( missingCompoundSelector(this) ) { return null; }
				this.lastItem===' ' && --this.length;
				return ( this[TOKEN.parent][TOKEN.parent]              ).block;
			case ')':
				if ( this.pseudoLiteral ) {
					if ( missingCompoundSelector(this) ) { return null; }///if ( this.lastItem===',' ) { return null; }
					( this.lastItem===' ' ) && --this.length;
					if ( !this.length ) { return null; }
					return this[TOKEN.parent];
				}
				else {
					if ( !inNthChild(this) ) { return null; }
					if ( missingCompoundSelector(this) ) { return null; }
					( this.lastItem===' ' ) && --this.length;
					return this[TOKEN.parent][TOKEN.parent][TOKEN.parent];
				}
			//case TOKEN.number:
			//case TOKEN.dimension:
			//case TOKEN.comment:
			//case '(':
			//case '-':
			//case TOKEN.url:
			//case '!':
			//case '$':
			//case '/':
			//case TOKEN.string:
			//case TOKEN.percentage:
			//case '?':
		}
		return null;
	}
	
	[Symbol.toPrimitive] (                     ) {
		return this.pseudoLiteral ? `${this.pseudoLiteral}(${this.join('')})` : this.join('');
	}
	
	* [Symbol.iterator] (                     ) { throw TypeError(`beautify complexSelector`); }
	
	                                                       
	
	static default = protect(this);
	
}

export default class SelectorList extends Layer                  {
	
	get [Symbol.toStringTag] () { return 'SelectorList'; }
	
	constructor (parent                      ) {
		super();
		this[TOKEN.parent] = parent;
		return this;
	}
	
	[TOKEN.consume] (                     ) {
		TOKEN.stay();
		return this.newItem = new ComplexSelector('');
	}
	
	[Symbol.toPrimitive] (                  ) {
		return this.join(',');
	}
	
	* [Symbol.iterator] (                  ) { throw TypeError(`beautify selectorList`); }
	
	                                             
	
	static default = protect(this);
	
};

                                         